/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Loader from "../common/loader";
import { MasterService } from "../../services";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const ViewAppVersion = () => {
    const { id: versionId } = useParams();
    const historyLead = useNavigate();

    const [loading, setLoading]           = useState(false);
    const [versionDetails, setVersionDetails] = useState({});
    const [tenantList, setTenantList]     = useState([]);

    useEffect(() => {
        getTenantList();
        if (versionId) fetchVersionDetails(versionId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [versionId]);

    // ── Data fetching ────────────────────────────────────────────────────────────

    const getTenantList = async () => {
        try {
            const response = await MasterService.post("/sfa/admin/get_tenant_list", {});
            if (response && response.data && response.data.status === 200) {
                setTenantList(response.data.data);
            }
        } catch (_) {}
    };

    const fetchVersionDetails = async (id) => {
        setLoading(true);
        try {
            const response = await MasterService.post("/sfa/admin/get_app_version_details", { id: parseInt(id) });
            if (response && response.data && response.data.status === 200) {
                setVersionDetails(response.data.data);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    };

    const getTenantLabel = (tenantValue) => {
        const found = tenantList.find((t) => t.tenant_value === tenantValue);
        return found ? found.tenant_label : (tenantValue || '-');
    };

    // ── Helpers ──────────────────────────────────────────────────────────────────

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        return new Date(dateStr).toLocaleDateString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const handleEdit = () => {
        historyLead(`/app-version-form/${versionId}`);
    };

    const handleBack = () => {
        historyLead("/app-version-management");
    };

    // ── Render ───────────────────────────────────────────────────────────────────

    return (
        <React.Fragment>
            {loading ? <Loader /> : null}
            <div className="container-fluid">
                <div className="agent-detail-tads">
                    <div className="preview-confirmation add-user-detail-filed">

                        <div className="top-heading d-flex">
                            <h2>App Version Details</h2>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <a onClick={handleEdit} className="edit-opt">Edit</a>
                                <a onClick={handleBack} className="edit-opt" style={{ color: '#666' }}>← Back to List</a>
                            </div>
                        </div>

                        <div className="d-flex">
                            <div className="role-detail-preview preview-basic-details">
                                <h3>Version Information</h3>
                                <ul>
                                    <li>
                                        <span>Entity / Tenant</span>
                                        <label><strong>{getTenantLabel(versionDetails.tenant_id)}</strong></label>
                                    </li>
                                    <li>
                                        <span>Platform (Source)</span>
                                        <label style={{ textTransform: 'capitalize' }}>
                                            {versionDetails.source || '-'}
                                        </label>
                                    </li>
                                    <li>
                                        <span>Version</span>
                                        <label><strong>{versionDetails.version || '-'}</strong></label>
                                    </li>
                                    <li>
                                        <span>Launch Type</span>
                                        <label>
                                            <span style={{
                                                color: versionDetails.launch_type === 'force' ? '#e74c3c' : '#27ae60',
                                                fontWeight: 600,
                                                textTransform: 'capitalize'
                                            }}>
                                                {versionDetails.launch_type || '-'}
                                            </span>
                                        </label>
                                    </li>
                                    <li>
                                        <span>Status</span>
                                        <label>
                                            <span style={{
                                                color: versionDetails.status === '1' ? '#27ae60' : '#e74c3c',
                                                fontWeight: 600
                                            }}>
                                                {versionDetails.status === '1' ? 'Active' : 'Inactive'}
                                            </span>
                                        </label>
                                    </li>
                                </ul>
                            </div>

                            <div className="role-detail-preview preview-basic-details">
                                <h3>App URLs</h3>
                                <ul>
                                    <li>
                                        <span>Android App URL</span>
                                        <label>
                                            {versionDetails.android_app_url
                                                ? <a href={versionDetails.android_app_url} target="_blank" rel="noreferrer">
                                                    {versionDetails.android_app_url}
                                                  </a>
                                                : '-'}
                                        </label>
                                    </li>
                                    <li>
                                        <span>iOS App URL</span>
                                        <label>
                                            {versionDetails.ios_app_url
                                                ? <a href={versionDetails.ios_app_url} target="_blank" rel="noreferrer">
                                                    {versionDetails.ios_app_url}
                                                  </a>
                                                : '-'}
                                        </label>
                                    </li>
                                    <li>
                                        <span>Update Message</span>
                                        <label style={{ whiteSpace: 'pre-wrap' }}>
                                            {versionDetails.message || '-'}
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="d-flex" style={{ marginTop: '20px' }}>
                            <div className="role-detail-preview preview-basic-details">
                                <h3>Audit Info</h3>
                                <ul>
                                    <li>
                                        <span>Created Date</span>
                                        <label>{formatDate(versionDetails.created_date)}</label>
                                    </li>
                                    <li>
                                        <span>Last Updated</span>
                                        <label>{formatDate(versionDetails.update_date)}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ViewAppVersion;
